import React, { ReactNode } from "react";

export const StickyHeader: React.FC<{ id: string; children: ReactNode }> = (
    props
) => {
    return <>{props.children}</>;

    /*
    return (
        <Sticky
            scrollElement=".app-scroll-area"
            boundaryElement={`.sticky-container-${props.id}`}
        >
            {props.children}
        </Sticky>
    );
    */
};
